import { fsDateUtils } from './fsDateUtils';

/**
 * Filter to format a date according to the settings
 */
/** @ngInject */
export function fsDateTimeFilter($cookies, userService) {
    return htmlCode => fsDateUtils.toString(htmlCode, userService, $cookies,
            format => format,true);
}
